import React from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";

import NQueen from "./NQueen";
import Navbar from "./ReusableParts/Navbar";
import Sudoku from "./Sudoku";
import Home from "./Home";
function App() {
  return (
    <div className="App">
      {/* <Navbar /> */}
      <Routes>
        <Route path="sudoku" element={<Sudoku />} />
        <Route path="nqueen" element={<NQueen />} />
        <Route path="/" element={<Home />} />
      </Routes>
    </div>
  );
}

export default App;
